// extracted by mini-css-extract-plugin
export default {"giftOrPromoRowWrapper":"wv-z","giftOrPromoSelector":"xv-z","disabled":"yv-z","subTitle":"zv-z","selectShipAddressMessage":"Av-z","changePayment":"Bv-z"};